export const mockDocuments = [
  {
    id: 'doc-001',
    name: '员工行为规范管理制度 2024版',
    type: 'PDF',
    size: '2.3 MB',
    uploadDate: '2024-01-15',
    status: '已归档',
    parseScope: '全文',
    version: 'v2.0',
    previousVersion: 'v1.0',
    rulesExtracted: 47,
    department: '人力资源部',
    domain: '行政域',
    uploader: '张经理'
  },
  {
    id: 'doc-002',
    name: '财务报销流程规定',
    type: 'Word',
    size: '1.8 MB',
    uploadDate: '2024-01-12',
    status: '解析中',
    parseScope: '第1-5章',
    version: 'v1.0',
    previousVersion: null,
    rulesExtracted: 0,
    department: '财务部',
    domain: '财务域',
    uploader: '李主管'
  },
  {
    id: 'doc-003',
    name: '项目管理办法',
    type: 'PDF',
    size: '3.1 MB',
    uploadDate: '2024-01-10',
    status: '已归档',
    parseScope: '全文',
    version: 'v3.1',
    previousVersion: 'v3.0',
    rulesExtracted: 62,
    department: '项目管理部',
    domain: '行政域',
    uploader: '王总监'
  },
  {
    id: 'doc-004',
    name: '信息安全管理规范',
    type: 'PDF',
    size: '4.2 MB',
    uploadDate: '2024-01-08',
    status: '待审核',
    parseScope: '全文',
    version: 'v1.5',
    previousVersion: 'v1.4',
    rulesExtracted: 38,
    department: '技术部',
    domain: '行政域',
    uploader: '陈工程师'
  },
  {
    id: 'doc-005',
    name: '采购管理制度',
    type: 'Word',
    size: '2.6 MB',
    uploadDate: '2024-01-05',
    status: '已归档',
    parseScope: '全文',
    version: 'v2.3',
    previousVersion: 'v2.2',
    rulesExtracted: 51,
    department: '采购部',
    domain: '财务域',
    uploader: '赵主任'
  },
  {
    id: 'doc-006',
    name: '质量控制标准',
    type: 'PDF',
    size: '5.4 MB',
    uploadDate: '2024-01-03',
    status: '已归档',
    parseScope: '全文',
    version: 'v4.0',
    previousVersion: 'v3.9',
    rulesExtracted: 89,
    department: '质量管理部',
    domain: '生产域',
    uploader: '孙经理'
  },
  {
    id: 'doc-007',
    name: '生产安全操作规程',
    type: 'PDF',
    size: '3.8 MB',
    uploadDate: '2024-01-02',
    status: '待解析',
    parseScope: '全文',
    version: 'v1.0',
    previousVersion: null,
    rulesExtracted: 0,
    department: '生产部',
    domain: '生产域',
    uploader: '李经理'
  },
  {
    id: 'doc-008',
    name: '供应商管理办法',
    type: 'Word',
    size: '2.1 MB',
    uploadDate: '2024-01-01',
    status: '解析中',
    parseScope: '全文',
    version: 'v2.0',
    previousVersion: 'v1.9',
    rulesExtracted: 0,
    department: '采购部',
    domain: '财务域',
    uploader: '赵主任'
  }
];

export const mockRules = [
  {
    id: 'rule-001',
    title: '员工请假需提前3个工作日申请',
    content: '员工因事请假，应提前3个工作日向直属上级提交书面请假申请，经批准后方可休假。紧急情况除外，但需在24小时内补办手续。',
    sourceDoc: '员工行为规范管理制度 2024版',
    sourceDocId: 'doc-001',
    department: ['人力资源部', '全体部门'],
    category: '考勤管理',
    references: 156,
    status: '已发布',
    createdDate: '2024-01-15',
    lastModified: '2024-01-15',
    tags: ['请假', '考勤', '流程']
  },
  {
    id: 'rule-002',
    title: '差旅费用报销标准及流程',
    content: '员工因公出差产生的交通费、住宿费、餐饮费等，应在出差结束后10个工作日内，凭合规发票和审批单据到财务部办理报销。超出标准部分需特别说明。',
    sourceDoc: '财务报销流程规定',
    sourceDocId: 'doc-002',
    department: ['财务部', '全体部门'],
    category: '财务管理',
    references: 203,
    status: '已发布',
    createdDate: '2024-01-12',
    lastModified: '2024-01-12',
    tags: ['报销', '差旅', '财务']
  },
  {
    id: 'rule-003',
    title: '项目立项需经过三级审批',
    content: '新项目立项必须经过部门主管、项目管理办公室、公司领导三级审批流程。项目金额超过50万元的，还需董事会批准。',
    sourceDoc: '项目管理办法',
    sourceDocId: 'doc-003',
    department: ['项目管理部'],
    category: '项目管理',
    references: 89,
    status: '已发布',
    createdDate: '2024-01-10',
    lastModified: '2024-01-10',
    tags: ['立项', '审批', '项目']
  },
  {
    id: 'rule-004',
    title: '密码强度及更换周期要求',
    content: '所有员工的系统密码必须包含大小写字母、数字和特殊字符，长度不少于10位。密码需每90天强制更换一次，不得重复使用最近5次的密码。',
    sourceDoc: '信息安全管理规范',
    sourceDocId: 'doc-004',
    department: ['技术部', '全体部门'],
    category: '信息安全',
    references: 312,
    status: '已发布',
    createdDate: '2024-01-08',
    lastModified: '2024-01-08',
    tags: ['密码', '安全', '信息']
  },
  {
    id: 'rule-005',
    title: '采购合同审批权限划分',
    content: '采购合同根据金额划分审批权限：5万元以下由部门主管审批；5-20万元由采购总监审批；20-100万元由分管副总审批；100万元以上由总经理审批。',
    sourceDoc: '采购管理制度',
    sourceDocId: 'doc-005',
    department: ['采购部'],
    category: '采购管理',
    references: 127,
    status: '已发布',
    createdDate: '2024-01-05',
    lastModified: '2024-01-05',
    tags: ['采购', '合同', '审批']
  },
  {
    id: 'rule-006',
    title: '产品质量检验抽样比例',
    content: '产品出厂前必须进行质量检验。批量生产的产品按10%比例抽样检验；定制产品需100%全检；关键部件需进行功能性测试和耐久性测试。',
    sourceDoc: '质量控制标准',
    sourceDocId: 'doc-006',
    department: ['质量管理部'],
    category: '质量控制',
    references: 98,
    status: '已发布',
    createdDate: '2024-01-03',
    lastModified: '2024-01-03',
    tags: ['质量', '检验', '标准']
  }
];

export const mockAgents = [
  {
    id: 'agent-001',
    name: '人事助手',
    description: '处理员工考勤、请假、薪资等人事相关咨询',
    ruleSetId: 'ruleset-001',
    ruleSetName: '人力资源规则集',
    documentsCount: 3,
    rulesCount: 47,
    status: '运行中',
    apiEndpoint: 'https://api.example.com/agents/hr-assistant',
    apiKey: 'ak_hr_2024***********',
    callsToday: 1247,
    callsTotal: 45672,
    createdDate: '2023-12-01',
    lastCall: '2024-01-15 14:23:15'
  },
  {
    id: 'agent-002',
    name: '财务顾问',
    description: '解答报销流程、费用标准等财务问题',
    ruleSetId: 'ruleset-002',
    ruleSetName: '财务管理规则集',
    documentsCount: 5,
    rulesCount: 51,
    status: '运行中',
    apiEndpoint: 'https://api.example.com/agents/finance-advisor',
    apiKey: 'ak_fin_2024***********',
    callsToday: 856,
    callsTotal: 32145,
    createdDate: '2023-12-05',
    lastCall: '2024-01-15 14:18:42'
  },
  {
    id: 'agent-003',
    name: '项目管理助手',
    description: '协助项目立项、进度跟踪、资源调配',
    ruleSetId: 'ruleset-003',
    ruleSetName: '项目管理规则集',
    documentsCount: 8,
    rulesCount: 62,
    status: '运行中',
    apiEndpoint: 'https://api.example.com/agents/pm-assistant',
    apiKey: 'ak_pm_2024***********',
    callsToday: 423,
    callsTotal: 18934,
    createdDate: '2023-12-10',
    lastCall: '2024-01-15 13:56:28'
  },
  {
    id: 'agent-004',
    name: '安全合规顾问',
    description: '提供信息安全、数据合规方面的指导',
    ruleSetId: 'ruleset-004',
    ruleSetName: '信息安全规则集',
    documentsCount: 2,
    rulesCount: 38,
    status: '测试中',
    apiEndpoint: 'https://api.example.com/agents/security-advisor',
    apiKey: 'ak_sec_2024***********',
    callsToday: 67,
    callsTotal: 2341,
    createdDate: '2024-01-08',
    lastCall: '2024-01-15 12:45:33'
  }
];

export const mockStatistics = {
  totalDocuments: 156,
  totalRules: 1247,
  totalAgents: 23,
  totalCalls: 234567,
  documentsThisMonth: 18,
  rulesThisMonth: 186,
  callsThisMonth: 45632,
  averageExtractionRate: 0.89,
  popularDomains: [
    { name: '行政域', count: 147 },
    { name: '财务域', count: 102 },
    { name: '生产域', count: 89 }
  ],
  monthlyTrend: [
    { month: '2026-08', documents: 12, rules: 95, calls: 28430 },
    { month: '2026-09', documents: 15, rules: 118, calls: 31245 },
    { month: '2026-10', documents: 11, rules: 87, calls: 29876 },
    { month: '2026-11', documents: 14, rules: 102, calls: 35421 },
    { month: '2026-12', documents: 16, rules: 134, calls: 38956 },
    { month: '2027-01', documents: 18, rules: 186, calls: 45632 }
  ]
};
